export default {"src":"/_next/static/media/arrowdown.e1d28a41.svg","height":8,"width":13,"blurWidth":0,"blurHeight":0};